export default "__VITE_ASSET__CqS8bf0l__"